import React, { useState } from 'react';
import { push } from 'connected-react-router';

import { logAndCaptureMessage } from 'utils';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { OccupationType } from 'lib/enums';
import { selectUser } from 'redux/auth';
import { exists } from 'lib/types';
import api from 'api';
import {
  ORGANIZATION_POST_REGISTRATION_ENTRYPOINT,
  INDIVIDUAL_REGISTRATION_ENTRYPOINT,
  PUBLISHER_REGISTRATION_ENTRYPOINT
} from 'redux/router';
import Occupations from './Occupations';

export default function OccupationsRoute() {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const [occupationType, setOccupationType] = useState<number>();
  const [loading, setLoading] = useState(false);

  const nextButtonClicked = async () => {
    if (occupationType !== null) {
      await completeBasicSignup();
    }
  };

  const completeBasicSignup = async () => {
    if (!exists(user)) return;
    setLoading(true);

    const response = await api.post('users/assign-occupation', {
      email: user.data().email,
      occupation: occupationType
    });
    if (response.success) {
      // Artifical delay before navigating to avoid showing a glimpse of previous screen
      setTimeout(() => {
        if (occupationType === OccupationType.individual.value) {
          dispatch(push(INDIVIDUAL_REGISTRATION_ENTRYPOINT));
        } else if (occupationType === OccupationType.publishing.value) {
          dispatch(push(PUBLISHER_REGISTRATION_ENTRYPOINT));
        } else {
          dispatch(push(ORGANIZATION_POST_REGISTRATION_ENTRYPOINT));
        }
      }, 500);
    } else {
      setLoading(false);
      logAndCaptureMessage(response.error);
    }
  };

  return (
    <Occupations
      occupationType={occupationType}
      onOccupationTypeChange={setOccupationType}
      onOccupationSelect={nextButtonClicked}
      loading={loading}
    />
  );
}
